// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import {
    Field, Form, reduxForm,
} from 'redux-form';
import Notification from '../../notification';
import InputField from './customFields/InputField';
import ReactSelectField from './customFields/ReactSelectField';
import SectionContainerOneCol from '../SectionContainerOneCol';
import { white as customSelectStyle } from '../../../utils/customSelectStyle';
import Select from 'react-select';

const options = [
    { label: 'Required', value: true },
    { label: 'Not Required', value: false },
];

// --- Validation helpers ---
const specialCharRegex = /^[a-zA-Z0-9\s-_]+$/;

const validateNoSpecialChars = (value) => {
    if (!value) return undefined;
    return specialCharRegex.test(value)
        ? undefined
        : 'Special characters are not allowed';
};

const requiredField = (value) =>
    value && value.trim() !== '' ? undefined : 'This field is required';

// --- Component ---
let CreateClientApprovalCodeReduxForm = ({
                                             handleSubmit,
                                             error,
                                             disabled,
                                             initialValues,
                                             change,
                                         }) => {

    useEffect(() => {
        if (initialValues?.hasOwnProperty('isRequired')) {
            const selectedOption = options.find(
                (o) => o.value === initialValues.isRequired
            );
            change('isRequired', selectedOption);
        }
    }, [initialValues]);

    useEffect(() => {
        if (error) Notification('error', { message: error });
    }, [error]);

    const preventSubmitOnEnter = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    return (
        <Form
            onSubmit={handleSubmit}
            onKeyPress={preventSubmitOnEnter}
        >
            <SectionContainerOneCol>

                <div className="field_block">
                    <Field
                        name="name"
                        component={InputField}
                        type="text"
                        placeholder="Approval Code Name"
                        label="Name"
                        required
                        className="flex-column"
                        inputClassName="width-100-percent input-field"
                        paddingBottomClassName="no-paddings"
                        disabled={disabled}
                        validate={[requiredField, validateNoSpecialChars]}
                    />
                </div>

                <Field
                    name="isRequired"
                    component={ReactSelectField}
                    className="flex-column"
                    label="Is Required"
                    options={options}
                    required
                    paddingBottomClassName="no-paddings"
                    inputClassName="width-inherit input-field no-paddings"
                    customSelectStyleType="white"
                    isSearchable={false}
                />

            </SectionContainerOneCol>
        </Form>
    );
};

CreateClientApprovalCodeReduxForm = reduxForm({
    form: 'createClientApprovalCodeReduxForm',
})(CreateClientApprovalCodeReduxForm);

export default CreateClientApprovalCodeReduxForm;
